// extracted by mini-css-extract-plugin
export var subtitle = "_b6-2";
export var title = "_b6-0";
export var titleNoWrap = "_b6-1";